import {
  ServiceChoice
} from '../abstract'
import {
  IServiceTypePrice,
  IServiceTypePriceData
} from '../index'


export interface IServiceTypeFilterData {
  readonly type: ServiceChoice
}

export interface IServiceTypeSimpleData {
  readonly id?: number
  readonly type?: ServiceChoice
  note?: string
  name?: string
  description?: string
}

export interface IServiceTypeSimple extends IServiceTypeSimpleData {
  name: string
  readonly type: ServiceChoice
  validate(): boolean
  update(data?: IServiceTypeSimpleData): void
  key: string
}


export interface IServiceTypeData extends IServiceTypeSimpleData {
  special?: string
  prices?: IServiceTypePriceData[]
}

export interface IServiceType extends IServiceTypeData {
  name: string
  readonly type: ServiceChoice
  prices: IServiceTypePrice[]

  validate(): boolean

  update(data?: IServiceTypeData): void

  key: string

}

export interface ISeparatedServiceTypes {
  consultations: IServiceType[]
  other: IServiceType[]
}

export const SERVICE_TYPE_NAME_MAX_LENGTH = 100
